import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import axios from "axios";
import "../index.css";
import { Link } from "react-router-dom";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";

import picPlaceholder from "../components/people.jpg";

const MemberList = () => {
  const [members, setMembers] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const isAfl = useSelector((state) => state.user.user?.type === "Afl");
  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");
  const isUser = useSelector((state) => state.user.user?.type === "User");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredMembers, setFilteredMembers] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [filter, setFilter] = useState({
    matricule: "",
    societe: "",
    status: "",
    telephone: "",
    noms: "",
    date: "",
  });

  useEffect(() => {
    const getMemberList = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/santymed/member-list-test`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          method: "POST",
        }
      );

      const parseRes = await response.json();
      if (parseRes.success === true) {
        console.log(parseRes.Result);
        setMembers(parseRes.Result);
        setFilteredMembers(parseRes.Result);
      }
    };
    getMemberList();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  };

  useEffect(() => {
    const applyFilters = () => {
      const { matricule, societe, status, telephone, noms, date } = filter;
      const filtered = members.filter((item) => {
        return (
          (matricule === "" ||
            (item.matricule &&
              item.matricule
                .toLowerCase()
                .includes(matricule.toLowerCase()))) &&
          (societe === "" ||
            (item.societe &&
              item.societe.toLowerCase().includes(societe.toLowerCase()))) &&
          (status === "" ||
            (status === "Active" ? item.isactive : !item.isactive)) &&
          (telephone === "" ||
            (item.telephone && item.telephone.includes(telephone))) &&
          (noms === "" ||
            `${item.prenom?.toLowerCase() || ""} ${
              item.nom?.toLowerCase() || ""
            }`.includes(noms.toLowerCase())) &&
          (date === "" ||
            (item.date_de_naissance &&
              new Date(item.date_de_naissance).toLocaleDateString() ===
                new Date(date).toLocaleDateString()))
        );
      });
      setFilteredMembers(filtered);
    };

    applyFilters();
  }, [filter, members]);

  const handlePhotoClick = (photoUrl) => {
    setSelectedPhoto(photoUrl);
  };

  // Calculate pagination data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  let currentItems = filteredMembers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Function to generate pagination buttons
  const getPaginationButtons = () => {
    const pageNumbers = [];
    const maxPageButtons = 5; // Adjust as needed
    let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

    if (endPage - startPage + 1 < maxPageButtons) {
      startPage = Math.max(1, endPage - maxPageButtons + 1);
    }

    if (startPage > 1) {
      pageNumbers.push(
        <li key={1} className="page-item">
          <button onClick={() => paginate(1)} className="page-link">
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pageNumbers.push(
          <li key="ellipsis-start" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${i === currentPage ? "active" : ""}`}
        >
          <button onClick={() => paginate(i)} className="page-link">
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(
          <li key="ellipsis-end" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pageNumbers.push(
        <li key={totalPages} className="page-item">
          <button onClick={() => paginate(totalPages)} className="page-link">
            {totalPages}
          </button>
        </li>
      );
    }

    return pageNumbers;
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedMembers = [...filteredMembers].sort((a, b) => {
    if (sortConfig.key) {
      let valueA = a[sortConfig.key];
      let valueB = b[sortConfig.key];

      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Update `currentItems` with sorted results
  currentItems = sortedMembers.slice(indexOfFirstItem, indexOfLastItem);

  // Handle change in items per page
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  return (
    <Layout>
      <div className="px-5 mt-3">
        <div className="d-flex justify-content-center">
          {isAfl && <h3 className="page-title">Liste Employés</h3>}
          {(isUser || isAdmin) && (
            <h3 className="page-title">Liste Patients</h3>
          )}
        </div>
        <div className="col-12 col-sm-6 col-md-4 category">
          Nombre de lignes : {filteredMembers.length}
        </div>
        <div>
          {selectedPhoto && (
            <div className="modal-overlay">
              <div className="modal-content">
                <img src={selectedPhoto} alt="Enlarged" />
                <button onClick={() => setSelectedPhoto(null)}>Close</button>
              </div>
            </div>
          )}
          <table className="table">
            <thead>
              <tr>
                {isAfl && <th className="category"></th>}
                {(isAdmin || isUser) && <th className="category"></th>}
                <th className="category">Photo</th>
                <th
                  className="category"
                  onClick={() => handleSort("matricule")}
                >
                  Matricule{" "}
                  {sortConfig.key === "matricule" &&
                    (sortConfig.direction === "asc" ? "🔼" : "🔽")}
                </th>
                <th className="category" onClick={() => handleSort("nom")}>
                  Nom{" "}
                  {sortConfig.key === "nom" &&
                    (sortConfig.direction === "asc" ? "🔼" : "🔽")}
                </th>
                <th className="category">Telephone</th>
                <th className="category">Date de naissance</th>
                <th className="category">Société</th>
                <th className="category">Crée le</th>
                <th className="category">Action</th>
              </tr>

              <tr>
                <th></th>
                <th></th>
                <th>
                  <input
                    type="text"
                    name="matricule"
                    placeholder="Matricule"
                    value={filter.matricule}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    name="noms"
                    placeholder="Nom"
                    value={filter.noms}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    name="telephone"
                    placeholder="Telephone"
                    value={filter.telephone}
                    onChange={handleFilterChange}
                    className="form-control"
                    disabled
                  />
                </th>
                <th>
                  <input
                    type="text"
                    name="date"
                    placeholder="MM-JJ-AAAA"
                    value={filter.date}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>
                <th>
                  <input
                    type="text"
                    name="societe"
                    placeholder="Société"
                    value={filter.societe}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((e) => (
                <tr key={e.matricule}>
                  {isAfl && (
                    <td>
                      {/* {e.rest_days > 0 ? (
                        <Tooltip title={`Repos: ${e.rest_days} jours`}>
                          <CloseCircleOutlined
                            style={{ color: "red", fontSize: "30px" }}
                          />
                        </Tooltip>
                      ) : (
                        <CheckCircleOutlined
                          style={{ color: "green", fontSize: "30px" }}
                        />
                      )} */}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        {e.assure ? "(AD)" : "(P)"}
                      </span>
                    </td>
                  )}
                  {(isUser || isAdmin) && (
                    <td>
                      {e.is_family_head === false && (
                        <p style={{ color: "red", fontSize: "24px" }}>AD</p>
                      )}
                    </td>
                  )}
                  <td>
                    {e.photo ? (
                      <img
                        className="member_photo"
                        src={
                          `http://localhost:3000/images/adherants/` + e.photo
                        }
                        onClick={() =>
                          handlePhotoClick(
                            `http://localhost:3000/images/adherants/` + e.photo
                          )
                        }
                      />
                    ) : (
                      <img
                        className="member-card-photo"
                        src={picPlaceholder}
                        onClick={() => handlePhotoClick(picPlaceholder)}
                      />
                    )}
                  </td>
                  <td className=" matricule">{e.matricule}</td>
                  <td>
                    {e.prenom} {e.nom}
                  </td>
                  <td>{e.telephone || "N/A"}</td>
                  <td>
                    {new Date(e.date_de_naissance).toLocaleDateString("fr-FR")}
                  </td>
                  <td>{e.societe || "N/A"}</td>
                  <td>
                    {new Date(e.created_at).toLocaleDateString()}{" "}
                    {new Date(e.created_at).toLocaleTimeString()}
                  </td>
                  <td>
                    <Link
                      to={`/member-entry-detail/${encodeURIComponent(
                        e.matricule
                      )}`}
                    >
                      <button
                        className="btn btn-secondary"
                        style={{
                          backgroundColor: "#005555",
                          marginRight: "2px",
                        }}
                      >
                        Detail
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="navs d-flex justify-content-between">
            <nav>
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    onClick={() => paginate(currentPage - 1)}
                    className="page-link"
                  >
                    Previous
                  </button>
                </li>
                {getPaginationButtons()}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    onClick={() => paginate(currentPage + 1)}
                    className="page-link"
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
            <div className="items-per-page-select">
              <label htmlFor="itemsPerPage">Items per page:</label>
              <select
                id="itemsPerPage"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                style={{ width: "auto", display: "inline-block" }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>
          <div>
            {(isUser || isAdmin) && (
              <Link to={`/family-card/`}>
                <button
                  style={{ backgroundColor: "#AF47E8" }}
                  className="btn btn-primary px-3 mt-2"
                >
                  Afficher cartes
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MemberList;
